<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-head">
            <h1>프리미엄 포인트 사용 방법</h1>
          </div>
          <div class="modal-con">
            <div class="modal-txt">
              <p>
                프리미엄 포인트는 온라인 장례식장,<br />
                온라인 행사장에서 선물 이모티콘을<br />
                구매하는 경우를 제외한,<br />
                모든 유료서비스에서 사용 가능합니다.<br />
                <span class="color-red">(단, 유료 이모티콘 구매는 제외됨)</span>
              </p>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn primary medium" @click="close">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const emits = defineEmits(['close']);

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 100);
};
</script>

<style scoped></style>
